export default __webpack_public_path__ + "static/media/exploreLeft.e3a0d435.png";